import React from 'react'
import { useState } from 'react';
function AddCustomer() {
     const [name, setName] = useState('');
     const [phone, setPhone] = useState('');
        const [email, setEmail] = useState('');
        const [country, setCountry] = useState('');
        const [city, setCity] = useState('');
        const [state, setState] = useState('');
        const [zip, setZip] = useState('');
        const [street, setStreet] = useState('');
        const [door, setDoor] = useState('');
        const [dob, setDob] = useState('');
        const [active, setActive] = useState(true);
        const [gender, setGender] = useState('');

        
  return (
    <>
        <div className='flex justify-center'>
                    <form  className='bg-white w-full '  >
                        <h1 className="text-2xl font-semibold text-gray-900">Add Customer</h1>
                    <div className='flex w-full mb-6 '>
                        <div className="flex flex-col w-1/3 mr-6">
                        <label
                            htmlFor="brand"
                            className="block text-sm font-medium text-gray-700 mt-4"
                        >
                            Customer Name
                        </label>
                        <input
                            type="text"
                            name="brand"
                            id="brand"
                            autoComplete="brand"
                            className="py-2 px-4 border-2 border-gray-300 focus:outline-none focus:border-blue-500 rounded-md"
                            onChange={(e)=>setName(e.target.value)
                            }
                            placeholder='Enter Category Name'
                        ></input>
                        </div>
                        <div className="flex flex-col w-1/3 mr-6">
                        <label
                            htmlFor="code"
                            className="block text-sm font-medium text-gray-700 mt-4"
                        >
                            Phone
                        </label>
                        <input
                            type="text"
                            name="code"
                            id="code"
                            autoComplete="code"
                            className="py-2 px-4 border-2 border-gray-300 focus:outline-none focus:border-blue-500 rounded-md"
                            placeholder='Enter Category Code'
                            onChange={(e)=>setPhone(e.target.value)}
                        ></input>
                        </div>
                        <div className="flex flex-col w-1/3 mr-6">
                        <label
                            htmlFor="active"
                            className="block text-sm font-medium text-gray-700 mt-4"
                        >
                            Email
                        </label>
                        <input
                            type="text"
                            name="active"
                            id="active"
                            placeholder='Enter Email '
                            className="py-2 px-4 border-2 border-gray-300 focus:outline-none focus:border-blue-500 rounded-md"
                            onChange={(e)=>setEmail(e.target.value)}
                        ></input>
                    </div>
                        </div>
                        <div className='flex w-full mb-6 '>
                        <div className="flex flex-col w-1/3 mr-6">
                        <label
                            htmlFor="active"
                            className="block text-sm font-medium text-gray-700 mt-4"
                        >
                            Country
                        </label>
                        <input
                            placeholder='Enter Country'
                            type="text"
                            name="active"
                            id="active"
                            className="py-2 px-4 border-2 border-gray-300 focus:outline-none focus:border-blue-500 rounded-md"
                            onChange={(e)=>setCountry(e.target.value)}
                        ></input>
                        </div>
                        <div className="flex flex-col w-1/3 mr-6">
                        <label
                            htmlFor="active"
                            className="block text-sm font-medium text-gray-700 mt-4"
                        >
                            City
                        </label>
                        <input
                            type="text"
                            name="active"
                            id="active"
                            placeholder='Enter City'
                            className="py-2 px-4 border-2 border-gray-300 focus:outline-none focus:border-blue-500 rounded-md"
                            onChange={(e)=>setCity(e.target.value)}
                        ></input>
                        </div>
                        <div className="flex flex-col w-1/3 mr-6">
                        <label
                            htmlFor="active"
                            className="block text-sm font-medium text-gray-700 mt-4"
                        >
                            State
                        </label>
                        <input
                            placeholder='Enter State'
                            type="text"
                            name="active"
                            id="active"
                            className="py-2 px-4 border-2 border-gray-300 focus:outline-none focus:border-blue-500 rounded-md"
                            onChange={(e)=>setState(e.target.value)}
                        ></input>
                    </div>
                        </div>
                    <div className='flex w-full mb-6 '>
                        <div className="flex flex-col w-1/3 mr-6">
                        <label
                            htmlFor="active"
                            className="block text-sm font-medium text-gray-700 mt-4"
                        >
                            Zip
                        </label>
                        <input
                            placeholder='Enter Zip'
                            type="text"
                            name="active"
                            id="active" 
                            className="py-2 px-4 border-2 border-gray-300 focus:outline-none focus:border-blue-500 rounded-md"
                            onChange={(e)=>setZip(e.target.value)}
                        ></input>
                        </div>
                        <div className="flex flex-col w-1/3 mr-6">
                        <label
                            htmlFor="active"
                            className="block text-sm font-medium text-gray-700 mt-4"
                        >
                            Street
                        </label>
                        <input
                            placeholder='Enter Street'
                            type="text"
                            name="active"
                            id="active"
                            className="py-2 px-4 border-2 border-gray-300 focus:outline-none focus:border-blue-500 rounded-md"
                            onChange={(e)=>setStreet(e.target.value)}
                        ></input>
                        </div>
                        <div className="flex flex-col w-1/3 mr-6">
                        <label
                            htmlFor="active"
                            className="block text-sm font-medium text-gray-700 mt-4"
                        >
                            Door
                        </label>
                        <input
                            placeholder='Enter Door'
                            type="text"
                            name="active"
                            id="active"
                            className="py-2 px-4 border-2 border-gray-300 focus:outline-none focus:border-blue-500 rounded-md"
                            onChange={(e)=>setDoor(e.target.value)}
                        ></input>
                        </div>
                        </div>
                        <div className="flex w-full">
                            <div className="flex flex-col w-1/3 mr-6">
                        <label
                            htmlFor="active"
                            className="block text-sm font-medium text-gray-700 mt-4"
                        >
                            Landmark
                        </label>
                        <input
                            placeholder='Enter Landmark'
                            type="text"
                            name="active"
                            id="active"
                            className="py-2 px-4 border-2 border-gray-300 focus:outline-none focus:border-blue-500 rounded-md"
                        ></input>
                        </div>
                        <div className="flex flex-col w-1/3 mr-6">
                        <label
                            htmlFor="active"
                            className="block text-sm font-medium text-gray-700 mt-4"
                        >
                            DOB
                        </label>
                        <input
                            placeholder='DOB'
                            type="date"
                            name="active"
                            id="active"
                            className="py-2 px-4 border-2 border-gray-300 focus:outline-none focus:border-blue-500 rounded-md"
                            onChange={(e)=>setDob(e.target.value)}
                        ></input>
                        </div>
                        
                        <div className="flex flex-col w-1/3 mr-6">
                        <label
                            htmlFor="active"
                            className="block text-sm font-medium text-gray-700 mt-4"
                        >
                            Gender
                        </label>
                        <select
                            name="active"
                            id="active"
                            className="py-2 px-4 border-2 border-gray-300 focus:outline-none focus:border-blue-500 rounded-md"
                            onChange={(e)=>setGender(e.target.value)}
                        >
                            <option value="male">male</option>
                            <option value="female">female</option>
                        </select>
                        </div>  
                        </div>
                        <div className="flex justify-center mt-10 mr-10">
                        <button
                            type="submit"
                            className="bg-green-500 text-white px-6 py-2 rounded-md"
                        >
                            Add Customer 
                        </button>
                        </div>

                    </form>
                </div>
    </>
  )
}

export default AddCustomer